/**
 *
 * Bill of material
 *
 */
import React from 'react';
import { useTheme } from 'styled-components';
import { Box } from '@eriksdigital/atomic-ui/components';
import { Text } from 'app/components/atoms';
import { ListItem } from 'app/components/molecules';
import { FormattedMessage } from 'react-intl';

export const BillOfMaterial = ({ billedItems }) => {
  const {
    colors: {
      default: { blue2 },
    },
    fonts: {
      default: {
        fontSize: { ft24 },
        fontWeight: { normal },
      },
    },
  } = useTheme();

  return (
    <>
      <Box
        data-testid="bill-of-material-title"
        marginTop="sp24"
        marginBottom="sp4"
      >
        <Text
          fontSize={ft24}
          fontWeight={normal}
          color={blue2}
          className="bold-style"
        >
          <FormattedMessage
            id="overview.bill-of-material.title"
            defaultMessage="Bill of material"
            description="Title text for bill of material block"
          />
        </Text>
      </Box>

      {billedItems &&
        billedItems.map(item => {
          return (
            <Box
              key={item.erpPartNumber}
              data-testid={item.erpPartNumber}
              width="100%"
            >
              {item && (
                <ListItem
                  key={item.erpPartNumber}
                  item={item}
                  isOverviewItem={true}
                />
              )}
            </Box>
          );
        })}
    </>
  );
};
